// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function AntDesigninstagramOutlinedIcon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 24 24"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M12.5 1c-2.985 0-3.36.014-4.533.066-1.173.055-1.972.24-2.672.511-.734.277-1.4.71-1.948 1.27a5.4 5.4 0 00-1.27 1.948c-.272.699-.457 1.499-.511 2.668C1.514 8.638 1.5 9.013 1.5 12s.014 3.36.066 4.534c.055 1.171.24 1.97.512 2.67a5.403 5.403 0 001.269 1.948c.61.612 1.223.989 1.947 1.27.7.272 1.498.457 2.67.511 1.174.052 1.548.066 4.536.066 2.988 0 3.36-.014 4.535-.066 1.17-.055 1.971-.24 2.671-.512a5.386 5.386 0 001.947-1.269 5.404 5.404 0 001.27-1.948c.27-.7.456-1.499.511-2.67.052-1.173.066-1.547.066-4.535 0-2.988-.014-3.362-.066-4.536-.055-1.17-.24-1.97-.512-2.669a5.4 5.4 0 00-1.269-1.948 5.379 5.379 0 00-1.948-1.27c-.701-.272-1.502-.457-2.672-.511C15.86 1.014 15.486 1 12.497 1h.004-.001zm-.986 1.983h.987c2.937 0 3.285.01 4.444.063 1.073.048 1.656.228 2.044.378.512.2.88.439 1.265.824a3.4 3.4 0 01.822 1.265c.151.386.33.97.378 2.042.054 1.159.065 1.507.065 4.442 0 2.936-.011 3.285-.065 4.444-.048 1.073-.228 1.654-.378 2.042a3.4 3.4 0 01-.824 1.264 3.4 3.4 0 01-1.265.822c-.385.151-.968.33-2.042.38-1.159.052-1.507.064-4.444.064-2.937 0-3.286-.012-4.445-.065-1.072-.049-1.654-.228-2.042-.379a3.407 3.407 0 01-1.265-.822 3.41 3.41 0 01-.825-1.265c-.15-.387-.33-.97-.378-2.042-.052-1.16-.063-1.507-.063-4.446 0-2.937.01-3.283.063-4.442.05-1.073.228-1.656.38-2.043.199-.513.438-.88.823-1.265.385-.385.75-.623 1.265-.823.388-.15.97-.33 2.042-.38 1.015-.046 1.408-.06 3.458-.061v.003zm6.859 1.826a1.32 1.32 0 100 2.64 1.32 1.32 0 000-2.64zM12.5 6.35a5.65 5.65 0 10-.176 11.3 5.65 5.65 0 00.176-11.3zm0 1.982a3.667 3.667 0 110 7.334 3.667 3.667 0 010-7.334z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default AntDesigninstagramOutlinedIcon
/* prettier-ignore-end */
